import cx from 'classnames';

import { SignalBadge } from '@/components/SignalBadge';
import { RiskKeys } from '@/config';

import styles from './OptionSignal.module.sass';

export type OptionSignalType = {
  isSelected?: boolean;
  value: RiskKeys;
  className?: string;
};

const OptionSignal = ({ isSelected, value, className }: OptionSignalType) => {
  const classes = cx(
    styles.option,
    {
      [styles['is-selected']]: isSelected,
    },
    className,
  );

  return <SignalBadge value={value} className={classes} />;
};

export default OptionSignal;
